// @flow

import { useLocationHref } from '@atlassian/mpac-ui';
import React from 'react';

import RedirectExternal from './RedirectExternal';

const useLoginUrl = (): string => {
  const currentUrl = useLocationHref();

  return `/login?redirect=${encodeURIComponent(currentUrl)}`;
};

const RedirectToLogin = () => {
  const loginUrl = useLoginUrl();
  return <RedirectExternal url={loginUrl} statusCode={302} />;
};

export default RedirectToLogin;
